import { render, staticRenderFns } from "./_Registration.vue?vue&type=template&id=4ebd4512&scoped=true"
import script from "./_Registration.vue?vue&type=script&lang=js"
export * from "./_Registration.vue?vue&type=script&lang=js"
import style0 from "./_Registration.vue?vue&type=style&index=0&id=4ebd4512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd4512",
  null
  
)

export default component.exports